module.exports = __webpack_public_path__ + "static/media/auth_picture.46d84e29.svg";